import { ROW_ELIGIBLE_QUESTION_TYPES } from '../components/CrosstabBuilder/utilities/constants';

export const CROSSTAB_BUILDER_TAB = { id: 'crosstab-builder', label: 'Crosstab Builder' };
export const TURF_SIMULATOR_TAB = { id: 'turf-simulator', label: 'TURF Simulator' };

export const hasTurfQuestion = (questions = []) => questions.some(({ turf }) => turf === true);

export const canShowCrosstabBuilderTab = ({
  isCrosstabBuilderGateEnabled = false,
  isStatsigLoading = false,
  publicToken,
  surveyQuestions,
} = {}) =>
  !publicToken &&
  !isStatsigLoading &&
  isCrosstabBuilderGateEnabled &&
  Boolean(surveyQuestions?.some(({ type }) => ROW_ELIGIBLE_QUESTION_TYPES.includes(type)));

export const canShowResponseQualityTab = ({
  isResponseQualityGateEnabled = false,
  isStatsigLoading = false,
  publicToken,
} = {}) => !publicToken && !isStatsigLoading && isResponseQualityGateEnabled;

export const canShowTurfSimulatorTab = ({
  isStatsigLoading = false,
  isTurfSimulatorGateEnabled = false,
  publicToken,
  surveyQuestions,
} = {}) =>
  !publicToken &&
  !isStatsigLoading &&
  isTurfSimulatorGateEnabled &&
  hasTurfQuestion(surveyQuestions);
